'use client';

import dynamic from 'next/dynamic';
import { useMemo } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    background: #fff;

    .ql-editor {
        min-height: 200px;

        strong,
        b {
            font-weight: 600;
        }
    }
`;

const modules = {
    toolbar: [
        // [{ header: [1, 2, 3, 4, false] }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
        ['link'],
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        // [{ font: [] }],
        [{ align: [] }],
        ['clean']
    ]
};

// Rich-text (Quill) field used by the Formular builder's "Textblock" field type.
const WYSIWYG = (props) => {
    const QuillNoSSRWrapper = useMemo(
        () =>
            dynamic(import('react-quill-new'), {
                ssr: false,
                loading: () => <div />
            }),
        []
    );

    // Forward editor changes, passing along the optional field identifier.
    const onChange = (e) => {
        props.onChange(e, props.data ? props.data : null);
    };

    return (
        <Wrapper>
            <QuillNoSSRWrapper theme="snow" value={props.value} onChange={onChange} modules={modules} />
        </Wrapper>
    );
};

export { WYSIWYG };
